import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { translate, Trans } from "react-i18next";

import style from "./style.css";
import consts from '../../consts/consts';

@translate()
export default class Table extends Component {
  formatDate(string) {
    const splits = string.split("-");
    return `${splits[2]}/${splits[1]}/${splits[0]}`;
  }

  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    const { appointments, modifyCallback, customClassRowItemLink, t } = this.props;
    return (
      <table className={finalRootClass} border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th className={style.header}>
              <Trans>Appointment</Trans>
            </th>
            <th className={style.header}>
              <Trans>Planned date</Trans>
            </th>
            <th className={style.header} />
            <th className={style.header}>
              <Trans>Additional information</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {appointments &&
            appointments.map((item, index) => {
              let prefixConst = process.env.APP_MODE === consts.mode.heyfix ? "_HEY" : "_OBE";
              let suffixConst = "";
              if (item.status === "pending" || item.status === "locked") {
                suffixConst = "_PENDING_OR_LOCKED";
              } else if (item.status === "done") {
                suffixConst = "_DONE";
              } else if (item.status === "cancel") {
                suffixConst = "_CANCEL";
              }

              let additionalInformation = "";
              if (suffixConst) {
                let translate = prefixConst + '_APPOINTMENT_ADD_INFO' + suffixConst;
                additionalInformation = t(translate);
              }

              return (
                <tr className={style.row} key={item.id}>
                  <td className={style.rowItem}>
                    <Trans>{item.type}</Trans>
                  </td>
                  <td className={classnames(style.rowItem, style.rowDate)}>
                    {this.formatDate(item.date)}
                    <br /> <Trans>{item.period}</Trans>
                  </td>
                  <td className={style.rowItem}>
                    {item.status === "open" && (
                      <span onClick={modifyCallback.bind(this, item)} className={[style.rowItemLink, customClassRowItemLink].join(' ')}>
                        <Trans>Modify</Trans>
                      </span>
                    )}
                  </td>
                  <td className={style.rowItem}>{additionalInformation}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  }
}

Table.propTypes = {
  rootClassname: PropTypes.string,
  modifyCallback: PropTypes.func,
  customClassRowItemLink: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Table/index.js